// Per-browser conveniences only (whether the panel is open, which
// conversation, where the launcher sits); storage can be missing or throw,
// and the console works without it.
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(key: string, value: string | null) {
  try {
    if (value === null) window.localStorage.removeItem(key)
    else window.localStorage.setItem(key, value)
  } catch {
    // private mode or blocked storage
  }
}
